import { render, staticRenderFns } from "./CollectionModal.vue?vue&type=template&id=4caf1a16&"
import script from "./CollectionModal.vue?vue&type=script&lang=js&"
export * from "./CollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionModal.vue?vue&type=style&index=0&id=4caf1a16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports